import { useQuery } from "@tanstack/react-query";
import type { PortalListingDTO } from "@colab/shared";
import { apiFetch, type ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// Single query behind BOTH the "My Listing" page and the top-nav gate — the
// nav item renders only when the response is configured + linked, so sharing
// the cache means the gate costs no extra request. Fail-soft by design: the
// endpoint returns { configured: false } / { linked: false } payloads instead
// of erroring when the marketplace connection is absent.
export function usePortalListing() {
  return useQuery<PortalListingDTO, ApiClientError>({
    queryKey: queryKeys.portal.listing(),
    queryFn: () => apiFetch<PortalListingDTO>("/portal/listing"),
    staleTime: 60_000,
  });
}
